import ServicioService from 'src/modules/servicio/servicioService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';
import ServicioListActions from 'src/modules/servicio/list/servicioListActions';

const prefix = 'SERVICIO_FORM';

const servicioFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: servicioFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await ServicioService.find(id);
      }

      dispatch({
        type: servicioFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: servicioFormActions.INIT_ERROR,
      });

      getHistory().push('/servicio');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: servicioFormActions.CREATE_STARTED,
      });

      await ServicioService.create(values);

      dispatch({
        type: servicioFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.servicio.create.success'),
      );

      // getHistory().push('/servicio');

      dispatch(ServicioListActions.doFetchCurrentFilter());
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: servicioFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: servicioFormActions.UPDATE_STARTED,
      });

      await ServicioService.update(id, values);

      dispatch({
        type: servicioFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.servicio.update.success'),
      );

      // getHistory().push('/servicio');

      dispatch(ServicioListActions.doFetchCurrentFilter());
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: servicioFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default servicioFormActions;
